<template>
  <div v-frag>
    <CardIeaAppMain>
      <div v-if="user.tipoUsuario == 'alumno'" style="width: 100%">
        <div v-if="docsPend == 0 && waiting == false" style="width: 100%">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title style="
                  display: flex;
                  justify-content: center;
                  background-color: rgb(58, 66, 153);
                  color: white;
                ">
                Documentación Completa
              </v-card-title>
            </v-card>
          </v-col>
        </div>
        <div v-else>
          <v-col v-if="docsPend > 0" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title> Documentos Requeridos: </v-card-title>
              <v-card-text>
                <ul class="text--primary">
                  <div v-for="(documento, index) in documentosAlumno" :key="index">
                    <li v-if="documento.validar == 0">
                      {{ documento.nameDocumento }}
                    </li>
                  </div>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
        </div>

        <v-col v-if="waiting == false" cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
          <v-card elevation="0" class="rounded-xl" color="secondaryApp">
            <v-card-title>
              {{ tituloNovedades }}
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                {{ descripcionNovedades }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <div class="text-center">
          <v-dialog v-model="dialog_pago_atrasado" width="700">
            <v-card>
              <v-card-text>
                <br />
                <h4>
                  Estimado/a alumno/a; al dia de la fecha tiene cuota/s impagas,
                  por favor procure realizar los pagos lo antes posible, a fin
                  de evitar el pasaje automático de su cuenta a estado de mora.
                  Puede regularizar su deuda desde la sección "Pagar curso"; o
                  enviar una consulta para que le indiquen los pasos a seguir.
                </h4>
              </v-card-text>
              <v-card-actions>
                <v-btn color="warning" block @click="dialog_pago_atrasado = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <div v-if="user.alumno_mora" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              Su usuario se encuentra en estado de Mora. Si desea retomar sus
              estudios, puede regularizar su deuda desde la sección Pagar curso;
              o enviar una consulta para que le indiquen los pasos a seguir para
              obtener el alta
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="user.borrado == '1'" style="width: 100%">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              Su usuario se encuentra dado de baja. Si desea retomar sus
              estudios, puede regularizar su deuda desde la sección Pagar curso;
              o enviar una consulta para que le indiquen los pasos a seguir para
              obtener el alta
            </v-alert>
          </v-col>
        </div>
      </div>

      <!-- <v-row justify="center" align-content="center" align="start"> -->
      <v-col cols="6" xs="6" sm="4" md="3" xl="2" lg="2" v-for="(item, index) in menuValidar" :key="index"
        align-self="start">
        <CardIeaCategory :text="item.text" :color="(user.borrado == '1' || user.alumno_mora) && item.validate
            ? '#dfdfdf'
            : item.color
          " :icon="require('../assets/categories/'+item.icon)" :newOption="item.new" v-if="(item.show && item.text != 'Administrá Tareas') ||
    (item.text == 'Administrá Tareas' && showButtonClock)
    " @press="menuAction(item.route, item.validate)" />
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
    <br />
    <div v-if="user.borrado !== '1' && user.alumno_mora !== true" style="margin-bottom: 85px">
      <div v-frag v-for="(item, i) in panels" :key="i">
        <v-card :class="$vuetify.breakpoint.name == 'xs'
            ? 'rounded-xl pr-4 pl-4'
            : 'rounded-xl pr-8 pl-8'
          " color="cardOne" v-if="item.id != 0" style="margin-bottom: 25px">
          <!-- <v-container :class="$vuetify.breakpoint.name == 'xs' ? '' :'pr-8 pl-8'" fluid> -->
          <v-row align="center" justify="center" align-content="center" v-if="user.tipoUsuario == 'alumno'">
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-row @click="openPanel(item)" no-gutters>
                <v-col cols="9" xs="9" sm="9" md="9" xl="9" lg="9" align-self="center">
                  <div class="text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text text--darken-2">
                    {{ item.text }}
                  </div>
                </v-col>
                <v-col cols="3" xs="3" sm="3" md="3" xl="3" lg="3" align-self="center" class="d-flex justify-end">
                  <v-avatar color="background" rounded class="rounded-lg" size="45">
                    <v-icon color="#8fc6dc" x-large v-if="!item.active">
                      mdi-menu-down
                    </v-icon>
                    <v-icon color="#8fc6dc" x-large v-if="item.active">
                      mdi-menu-up
                    </v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-expand-transition>
                <v-row v-show="item.active" align="center">
                  <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                    <!-- class room -->
                    <div v-frag v-if="item.id == 2">
                      <div v-frag v-for="(planDeEstudio, planDeEstudioKey) in item.data" :key="planDeEstudioKey">
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                          {{ planDeEstudio.CursoNombre }}
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Plan de estudio</th>
                                <th class="text-left">Código ClassRoom</th>
                                <th class="text-left">ClassRoom (BETA)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(
                                  planDeEstudioData, planDeEstudioDataKey
                                ) in planDeEstudio.planDeEstudio" :key="planDeEstudioDataKey">
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                    ? planDeEstudioData.catedraMin
                                    : planDeEstudioData.catedra
                                  }}
                                </td>
                                <td>{{ planDeEstudioData.codClassRoom }}</td>
                                <td>
                                  <div v-frag v-if="planDeEstudioData.link != ''">
                                    <v-btn @click="linkVideo(planDeEstudioData)" small
                                      class="info--text text-decoration-underline font-weight-regular" depressed text
                                      color="info">Ver Aquí</v-btn>
                                  </div>
                                  <div v-frag v-else>
                                    <b class="text-center">Sin contenido aún</b>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>
                    <!-- class room -->
                    <!-- mesa de exames -->
                    <div v-frag v-if="item.id == 1">
                      <v-card elevation="0">
                        <v-card-text v-if="item.data.cantidad > 0">
                          Cantidad de materia disponibles :
                          {{ item.data.cantidad }}
                        </v-card-text>
                        <v-card-text v-else>
                          Cantidad de materia disponibles : 0
                        </v-card-text>
                      </v-card>
                      <br />
                      <div v-frag v-for="(examenMesa, examenMesaKey) in item.data.data" :key="examenMesaKey">
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                          {{ examenMesa.curso.Feriado }}
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Examen</th>
                                <th class="text-center">Acción</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(
                                  planDeEstudioData, planDeEstudioDataKey
                                ) in examenMesa.curso.plan_de_estudio_v2" :key="planDeEstudioDataKey">
                                <td>{{ planDeEstudioData.Materia }}</td>
                                <td style="text-align: center">
                                  <div v-frag v-if="planDeEstudioData.tipo == 0">
                                    <v-btn @click="() => null" class="grey--text font-weight-regular" depressed text
                                      disabled color="grey">Sin Mesa Aún</v-btn>
                                  </div>
                                  <div v-frag v-if="examenMesa.curso.diasUltimaInscripcion <
                                    365 && planDeEstudioData.tipo == 1
                                    ">
                                    <v-btn v-show="item.data.cantidad > 0" style="border: 1px solid" @click="
                                      inscripcionMesaExamen(
                                        planDeEstudioData.IDStB,
                                        examenMesa.id
                                      )
                                      " depressed text color="primary">Inscribir</v-btn>
                                  </div>
                                  <div v-frag v-if="planDeEstudioData.tipo == 2">
                                    <v-alert color="info" style="
                                        background-color: rgba(
                                          100,
                                          181,
                                          246,
                                          0.2
                                        ) !important;
                                        border: 1px solid;
                                        padding: 5px;
                                        margin-bottom: 5px !important;
                                        margin-top: 5px !important;
                                        padding-left: 0px;
                                        padding-right: 0px;
                                      ">
                                      Esperando confirmación
                                      <v-btn @click="
                                        cancelarInscripcionMesaExamen(
                                          planDeEstudioData
                                            .examen_inscipcion_alumno[0]
                                            .id_validacion
                                        )
                                        " small class="red--text text-decoration-underline font-weight-regular"
                                        depressed text color="red">Cancelar</v-btn>
                                    </v-alert>
                                  </div>
                                  <div v-frag v-if="planDeEstudioData.tipo == 3">
                                    <div v-if="planDeEstudioData != null">
                                      <div v-if="planDeEstudioData.examen_asociado !=
                                        null &&
                                        planDeEstudioData.examen_asociado
                                          .tipo_link == 0
                                        ">
                                        <v-btn @click="
                                          linkPrueba(
                                            planDeEstudioData.examen_asociado
                                              .id_testpyr
                                          )
                                          " depressed style="border: 1px solid" text color="rgb(143, 198, 220)">
                                          Prueba
                                        </v-btn>
                                      </div>

                                      <div v-else-if="planDeEstudioData.examen_asociado !=
                                        null
                                        ">
                                        <v-btn :href="planDeEstudioData.examen_asociado
                                            .google_meet_url
                                          " depressed target="_blank" style="
                                            border: 1px solid;
                                            margin-left: 10px;
                                          " text color="rgb(219, 29, 74)">
                                          ClassRoom
                                        </v-btn>
                                      </div>

                                      <div v-else>
                                        <v-badge color="success" content="Inscripto" inline></v-badge>
                                      </div>
                                    </div>

                                    <div v-else>
                                      <v-btn @click="() => null" class="grey--text font-weight-regular" depressed text
                                        disabled color="grey">
                                        Sin Mesa Aún
                                      </v-btn>
                                    </div>
                                  </div>
                                  <div v-frag v-if="planDeEstudioData.tipo == 4">
                                    <v-badge color="error" content="Rechazado" inline></v-badge>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                      <br /><br />
                    </div>
                    <!-- mesa de exames -->

                    <!-- pagos -->
                    <div v-frag v-if="item.id == 3">
                      <div v-frag v-for="(itemTable, keyTable) in item.data" :key="keyTable">
                        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">
                          {{ itemTable.nombre }}
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Concepto</th>
                                <th class="text-left">Monto</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(
                                  itemTableData, keyItemTableData
                                ) in itemTable.data" :key="keyItemTableData">
                                <td>{{ itemTableData.Concepto }}</td>
                                <td>${{ itemTableData.Monto }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                      <br /><br />
                    </div>
                    <!-- pagos -->

                    <!-- test -->

                    <div v-frag v-if="item.id == 4">
                      <div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center">Nombre del Test</th>
                                <th class="text-center">Test (BETA)</th>
                                <th class="text-center">Formulario Google</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(test, keyTable) in item.data" :key="keyTable">
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                    ? test.titulo
                                    : test.titulo
                                  }}
                                </td>

                                <td v-if="test.tipo == 'Practica'">
                                  <div v-frag>
                                    <v-btn @click="linkTest(test)" small
                                      class="info--text text-decoration-underline font-weight-regular" depressed text
                                      color="info">Presentar Test</v-btn>
                                  </div>
                                </td>
                                <td v-else-if="test.tipo == 'Examen Final'">
                                  <div v-if="test.tipo_examen == 'Recuperatorio' &&
                                    test.presentarExamenRecuperatorio
                                    ">
                                    <div v-frag v-if="test.testPresentado == false">
                                      <v-btn @click="linkTest(test)" small
                                        class="info--text text-decoration-underline font-weight-regular" depressed text
                                        color="info">Presentar Test</v-btn>
                                    </div>

                                    <div v-frag v-else>
                                      <v-btn small color="success">Test Presentado</v-btn>
                                    </div>
                                  </div>

                                  <div v-else-if="test.tipo_examen === 'Examen Final' &&
                                    test.presentarExamenFinal === true
                                    ">
                                    <div v-frag v-if="test.testPresentado == false">
                                      <v-btn @click="linkTest(test)" small
                                        class="info--text text-decoration-underline font-weight-regular" depressed text
                                        color="info">Presentar Test</v-btn>
                                    </div>

                                    <div v-frag v-else>
                                      <v-btn small color="success">Test Presentado</v-btn>
                                    </div>
                                  </div>

                                  <div v-else-if="test.tipo_examen == '2do Parcial' ||
                                    test.tipo_examen == '1er Parcial'
                                    ">
                                    <div v-frag v-if="test.testPresentado == false">
                                      <v-btn @click="linkTest(test)" small
                                        class="info--text text-decoration-underline font-weight-regular" depressed text
                                        color="info">Presentar Test</v-btn>
                                    </div>

                                    <div v-frag v-else>
                                      <v-btn small color="success">Test Presentado</v-btn>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <v-btn :href="test.url_meet" small
                                    class="info--text text-decoration-underline font-weight-regular" depressed text
                                    color="info">Ver Aquí</v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>

                    <!-- test -->

                    <!-- test -->

                    <div v-frag v-if="item.id == 6">
                      <div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>

                                <th class="text-center">Materia</th>
                                <th class="text-center">Nombre del Test</th>
                                <th class="text-center">Tipo</th>
                                <th class="text-center">Fecha</th>
                                <th class="text-center">Hora</th>
                                <th class="text-center">Test (BETA)</th>
                                <th class="text-center">EN DESARROLLO</th>
                                <th class="text-center">Nota</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(test, keyTable) in item.data" :key="keyTable">
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                    ? test.nombreMateria
                                    : test.nombreMateria
                                  }}
                                </td>
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                    ? test.titulo
                                    : test.titulo
                                  }}
                                </td>
                                <td>
                                  <div v-if="test.tipo_examen != null">
                                    {{ test.tipo_examen }}
                                  </div>

                                  <div v-else>Practica</div>
                                </td>
                                <td>
                                  <div v-if="test.tipo != 'Practica'">
                                    <span class="font-weight-black red--text">
                                      Periodo Valido <br />
                                      {{ test.fecha_test_desde }} /
                                      {{ test.fecha_test_hasta }}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div v-if="test.tipo != 'Practica'">
                                    <span class="font-weight-black red--text">
                                      Horario Valido <br />
                                      {{ test.hora_inicio }} a
                                      {{ test.hora_final }}
                                    </span>
                                  </div>
                                </td>
                                <td v-if="test.tipo == 'Practica'">
                                  <div v-frag>
                                    <v-btn @click="linkTest(test)" small
                                      class="info--text text-decoration-underline font-weight-regular" depressed text
                                      color="info">Presentar Test</v-btn>
                                  </div>
                                </td>
                                <td v-else-if="test.tipo == 'Examen Final'">
                                  <div v-if="test.tipo_examen == 'Recuperatorio' &&
                                    test.presentarExamenRecuperatorio
                                    ">
                                    <div v-frag v-if="test.testPresentado == false">
                                      <v-btn @click="linkTest(test)" small
                                        class="info--text text-decoration-underline font-weight-regular" depressed text
                                        color="info">Presentar Test</v-btn>
                                    </div>

                                    <div v-frag v-else>
                                      <v-btn small color="success">Test Presentado</v-btn>
                                    </div>
                                  </div>

                                  <div v-else-if="test.tipo_examen === 'Examen Final' &&
                                    test.presentarExamenFinal === true
                                    ">
                                    <div v-frag v-if="test.testPresentado == false">
                                      <v-btn @click="linkTest(test)" small
                                        class="info--text text-decoration-underline font-weight-regular" depressed text
                                        color="info">Presentar Test</v-btn>
                                    </div>

                                    <div v-frag v-else>
                                      <v-btn small color="success">Test Presentado</v-btn>
                                    </div>
                                  </div>

                                  <div v-else-if="test.tipo_examen == '2do Parcial' ||
                                    test.tipo_examen == '1er Parcial'
                                    ">
                                    <div v-frag v-if="test.testPresentado == false">
                                      <v-btn @click="linkTest(test)" small
                                        class="info--text text-decoration-underline font-weight-regular" depressed text
                                        color="info">Presentar Test</v-btn>
                                    </div>

                                    <div v-frag v-else>
                                      <v-btn small color="success">Test Presentado</v-btn>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <v-btn :href="test.url_meet" small
                                    class="info--text text-decoration-underline font-weight-regular" depressed text
                                    color="info">Ver Aquí</v-btn>
                                </td>

                                <td>
                                  <div v-if="test.mostrar_nota">
                                    <div v-if="test.nota >= 4">
                                      <div class="my-2">
                                        <v-btn color="success" fab x-small dark>
                                          {{ test.nota }}
                                        </v-btn>
                                      </div>
                                    </div>
                                    <div v-else>
                                      <div class="my-2">
                                        <v-btn color="error" fab x-small dark>
                                          {{ test.nota }}
                                        </v-btn>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>

                    <!-- test -->

                    <!-- Materias Faltantes -->

                    <div v-frag v-if="item.id == 5">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Materia</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(
                                itemTableData, keyItemTableData
                              ) in materiaFaltantes" :key="keyItemTableData">
                              <td v-if="itemTableData.aprobada == false ||
                                itemTableData.examen_inscipcion_alumno ==
                                null ||
                                itemTableData.examen_inscipcion_alumno.notas
                                  .length == 0 ||
                                itemTableData.examen_inscipcion_alumno
                                  .notas[3].nota < 4
                                ">
                                {{ itemTableData.catedra }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <br /><br />
                    </div>

                    <!-- Materias Faltantes -->
                  </v-col>
                </v-row>
              </v-expand-transition>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card>
      </div>
    </div>
    <div v-if="sendvalidation">
      <DialogValidationAlumno />
    </div>
    <v-dialog v-model="apareceModalMedallaIncial" width="auto">
      <v-card>
        <v-card-title class="headline" primary-title>
          ¡Felicidades! 
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Has ganado el siguiente reconocimiento por haber ingresado por primera vez a nuestra plataforma

          <v-img class="mt-4" :aspect-ratio="16 / 9" width="150" contain
            :src="require('../assets/inicial.png')"></v-img>

        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="apareceModalMedallaIncial = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../components/CardIeaAppMain";
import CardIeaCategory from "../components/CardIeaCategory";
import DialogValidationAlumno from "../components/DialogValidationAlumno";

export default {
  name: "Home",
  components: {
    CardIeaAppMain,
    CardIeaCategory,
    DialogValidationAlumno,
  },
  created() {
    this.$API
      .get({
        url: "menus/W",
        data: {},
      })
      .then((res) => {
        this.menu = res.menus
      });
  },
  data: () => ({
    tituloNovedades: "",
    descripcionNovedades: "",
    sendvalidation: false,
    documentosAlumno: [],
    waiting: true,
    docsPend: 0,
    materiaFaltantes: [],
    dialog_pago_atrasado: false,
    menu: [
      
    ],

    panels: [
      {
        id: 0,
        text: "Tus Inscripciones a Materias",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
      },
      {
        id: 1,
        text: "Tus Inscripciones a Exámenes",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
      },
      /*
      {
        id: 2,
        text: "Plan de estudio y classroom",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
      */
      /*{
        id: 3,
        text: "Tus Pagos",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
      },
      */
      {
        id: 4,
        text: "Practicas",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
      },
      {
        id: 5,
        text: "Materias Que Me Faltan",
        active: false,
        data: [],
        tipoUsuario: ["alumno"],
        show: true,
      },
      {
        id: 6,
        text: "Parciales y Examenes Finales",
        active: false,
        data: [],
        tipoUsuario: "alumno",
        show: true,
      },
    ],
    showButtonClock: false,
    apareceModalMedallaIncial:false
  }), 
  computed: {
    tieneBadge1() {
      return this.$store.getters.tieneBadge1;
    },
    tieneBadge2() {
      return this.$store.getters.tieneBadge2;
    },
    tieneBadge3() {
      return this.$store.getters.tieneBadge3;
    },
    porcentaje1(){
      return this.$store.getters.porcentaje1;
    },
    porcentaje2(){
      return this.$store.getters.porcentaje2;
    },
    porcentaje3(){
      return this.$store.getters.porcentaje3;
    },
    user() {
      return this.$store.getters.user;
    },
    menuValidar: function () {
      let usuario = this.$store.getters.user;
      return this.menu.filter(function (m) {
        return m.tipoUsuario.includes(usuario.tipoUsuario);
      });
    },
    apareceModalInicial(){
      return this.$store.getters.apareceModalInicial;
    },
    primeroIngreso(){
      return this.$store.getters.primeroIngreso;
    }
  },
  mounted() {
    if (this.user.tipoUsuario == "alumno") {
      this.isActiveTramites();
      this.novedadesList();
      this.registerAccess();
      this.documentosRequeridos(this.user.IDStB);
      console.log(this.user.borrado);

      if(this.primeroIngreso && !this.apareceModalInicial){
       this.apareceModalMedallaIncial=true

        this.$store.commit('apareceModalInicial',true)
      }
    }
    console.log(this.user);
    if (
      this.user.IDStB == 11103 ||
      this.user.IDStB == 5680 ||
      this.user.kanban
    ) {
      this.showButtonClock = true;
    }

    if (!this.getCookie("mensajeImpago")) {
      this.showMensajeImpago();
    }
    this.$API
      .get({
        url: "menus/W",
        data: {},
      })
      .then((res) => {
        this.menu = res.menus
      });

  },
  methods: {
    async openPanel(item) {
      if (item.id == 2) {
        if (!item.active) {
          await this.planDeEstudioGet();
        } else {
          // this.panels[2].data = []
        }
      }
      if (item.id == 1) {
        if (!item.active) {
          await this.mesaDeExamen();
        } else {
          // this.panels[1].data = []
        }
      }
      if (item.id == 0) {
        if (!item.active) {
          await this.mesaDeMateria();
        } else {
          // this.panels[1].data = []
        }
      }

      if (item.id == 3) {
        if (!item.active) {
          await this.tuPagos();
        } else {
          // this.panels[1].data = []
        }
      }

      if (item.id == 4) {
        if (!item.active) {
          await this.testPrueba();
        } else {
          // this.panels[1].data = []
        }
      }

      if (item.id == 5) {
        if (!item.active) {
          await this.MateriasFaltan();
        } else {
          // this.panels[1].data = []
        }
      }
      if (item.id == 6) {
        if (!item.active) {
          await this.examenes();
        } else {
          // this.panels[1].data = []
        }
      }

      item.active = !item.active;
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const cookieValue = parts.pop().split(";").shift();
        return cookieValue;
      }
      return null;
    },

    async showMensajeImpago() {
      let app = this;

      await this.$API
        .get({
          url: "alumno/status-activo/" + this.user.IDStB,
          data: {},
        })
        .then((res) => {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          document.cookie = `mensajeImpago=${JSON.stringify(
            res
          )}; expires=${tomorrow.toUTCString()}; path=/`;
          app.dialog_pago_atrasado = res.is_active;
        });
    },

    async novedadesList() {
      //let that = this;
      await this.$API
        .get({
          url: "notificaciones/index",
          data: {},
        })
        .then((res) => {
          this.tituloNovedades = res[res.length - 1].titulo.toUpperCase();
          this.descripcionNovedades = res[res.length - 1].descripcion;
        });
    },
    async registerAccess() {
      await this.$API
        .post({
          url: "alumno/register-access",
          data: {
            tipo: "web",
          },
        })
        .then((res) => {
          console.log(res);
        });
    },

    documentosPendientes() {
      let app = this;
      if (typeof app.documentosAlumno !== "undefined") {
        app.docsPend = 0;
        for (const item in app.documentosAlumno) {
          if (app.documentosAlumno[item].validar == 0) app.docsPend++;
        }
      }
    },

    async documentosRequeridos(alumno) {
      //let that = this;
      await this.$API
        .get({
          url: "documentos/requeridos/" + alumno,
          data: {},
        })
        .then((res) => {
          this.waiting = false;
          this.documentosAlumno = res;
          this.documentosPendientes();
        });
    },
    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "alumno/logout?web=true",
          data: {},
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$store.dispatch("tieneBadge1",false)
            that.$store.dispatch("tieneBadge2",false)
            that.$store.dispatch("tieneBadge3",false)
            that.$store.dispatch("porcentaje1",0)
            that.$store.dispatch("porcentaje2",0)
            that.$store.dispatch("porcentaje3",0)
            that.$store.dispatch("primeroIngreso",false)
            that.$store.dispatch("apareceModalInicial",false)
            that.$store.dispatch("carreraPrincipal", "")
            that.$store.dispatch("imagenbs","")

            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    menuAction(route, validate) {
      if (
        route &&
        (validate == false ||
          (validate == true &&
            this.user.borrado !== "1" &&
            this.user.alumno_mora !== true))
      ) {
        if (route == "Logout") {
          this.logout();
        } else if (route == "Verifier") {
          this.$store.dispatch("omitirValidacion", false);
          this.sendvalidation = true;
        } else {
          console.log(route);
          this.$router.push({
            name: route,
          });
        }
      }
    },
    async testPrueba() {
      await this.$API
        .get({
          url: "pyr-test/select",
          data: {},
        })
        .then((res) => {
          this.panels.find((element) => element.id == 4).data = res;

          console.log("panel 4", this.panels[4].data);
        });
    },
    async examenes() {
      await this.$API
        .get({
          url: "examenes",
          data: {},
        })
        .then((res) => {
          this.panels.find((element) => element.id == 6).data = res;

          console.log("panel 6", this.panels[6]);
        });
    },
    async planDeEstudioGet() {
      await this.$API
        .get({
          url: "plan-de-estudio/index",
          data: {},
        })
        .then((res) => {
          this.panels[2].data = res;
        });
    },
    async mesaDeExamen() {
      await this.$API
        .get({
          url: "examen/mesas",
          data: {},
        })
        .then((res) => {
          this.panels[1].data = res;
        });
    },
    async mesaDeMateria() {
      await this.$API
        .get({
          url: "materia/mesas",
          data: {},
        })
        .then((res) => {
          this.panels[0].data = res;
        });
    },
    async tuPagos() {
      await this.$API
        .get({
          url: "alumno/pagos",
          data: {},
        })
        .then((res) => {
          this.panels[3].data = res;
        });
    },

    async inscripcionMesaExamen(examen, mesa) {
      await this.$API
        .post({
          url: "examen/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeExamen();
        });
    },
    async cancelarInscripcionMesaExamen(id) {
      await this.$API
        .post({
          url: "examen/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeExamen();
        });
    },

    async inscripcionMesaMateria(examen, mesa) {
      await this.$API
        .post({
          url: "materia/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async cancelarInscripcionMesaMateria(id) {
      await this.$API
        .post({
          url: "materia/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async isActiveTramites() {
      await this.$API
        .get({
          url: "get-config/ENABLE_TRAMITES",
          data: {},
        })
        .then((res) => {
          console.log(res);
          if (res == "1") {
            this.menu[22].show = true;
          }
        });
    },
    async MateriasFaltan() {
      await this.$API
        .post({
          url: "examenes/v2/showCursoIea",
          data: {
            alumno: this.user.IDStB,
          },
        })
        .then((res) => {
          let cursos = res.data;
          let materias;

          cursos.forEach((planestudio) => {
            console.log(planestudio.plan_de_estudio_v2.length !== 0);
            if (planestudio.plan_de_estudio_v2.length !== 0) {
              materias = planestudio.plan_de_estudio_v2.filter(
                (materia) => materia.aprobada === false
              );
              if (materias.length > 0) {
                this.materiaFaltantes = materias.reduce(
                  (acc, el) => ({
                    ...acc,
                    [el.catedra]: el,
                  }),
                  []
                );
              }
            }
          });

          console.log(this.materiaFaltantes);
        });
    },
    linkVideo(link) {
      this.$router.push({
        name: "MateriaCodigoClaseVideoAuth",
        params: {
          catedra: link.catedra_uuid,
          planestudio: link.planEstudio,
        },
      });
    },
    linkTest(test) {
      this.$router.push({
        name: "examen",
        params: {
          test: test.test_id,
          examen: test.id,
        },
      });
    },

    linkPrueba(idPrueba) {
      this.$router.push({
        name: "examen",
        params: {
          test: idPrueba,
        },
      });
    },
  },
};
</script>
